import axios from 'axios';
import { csrfTokenManager } from '../utils/csrfTokenManager';

/**
 * Gets airport IATA code for a city
 * @param cityName City name to look up
 * @returns Promise with IATA code
 */

export const getAirportCode = async (cityName: string): Promise<string> => {
  try {
    const API_BASE_URL = process.env.NODE_ENV === 'production' 
      ? 'https://travelapp-bens.onrender.com' 
      : 'http://localhost:5001';
    
    const url = `${API_BASE_URL}/api/airport/code?city=${encodeURIComponent(cityName)}`;
    console.log(`🔍 DEBUG: Calling airport API for ${cityName}: ${url}`);
    
    // Call the backend API endpoint (no CSRF needed for GET requests)
    const response = await fetch(url, {
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
      }
    });
    
    console.log(`🔍 DEBUG: Response status for ${cityName}: ${response.status} ${response.statusText}`);
    
    if (!response.ok) {
      const errorData = await response.json();
      console.error(`❌ DEBUG: API error for ${cityName}:`, errorData);
      throw new Error(`API error: ${errorData.error || response.statusText}`);
    }
    
    const data = await response.json();
    console.log(`🔍 DEBUG: Response data for ${cityName}:`, data);
    
    if (data.success && data.airportCode) {
      console.log(`✅ DEBUG: Found airport code for ${cityName}: ${data.airportCode}`);
      return data.airportCode;
    } else {
      // Fallback to city name if code not found
      console.warn(`⚠️ DEBUG: No airport code found for ${cityName}, API returned:`, data);
      console.warn(`⚠️ DEBUG: Falling back to city name: ${cityName}`);
      return cityName;
    }
  } catch (error) {
    console.error(`❌ DEBUG: Error getting airport code for ${cityName}:`, error);
    console.error(`❌ DEBUG: Falling back to city name: ${cityName}`);
    // Return city name as fallback
    return cityName;
  }
};